var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E33FAF8A-7C89-4D14-90B6-D3C28561B25C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E66783",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE6CC8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-34.8%",
    y: "-30.4%",
    width: "169.6%",
    height: "169.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.815686275   0 0 0 0 0.423529412   0 0 0 0 0.768627451  0 0 0 0.6 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LA-new-landing-page-V2",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "test",
    transform: "translate(8.099365, 4.892659)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.345790, 4.457001)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91746973,0.281494831 L3.96438553,0.281494831 C3.94092763,0.281494831 3.91746973,0.281494831 3.91746973,0.281494831 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6134181,0.281494831 L22.14426,0.281494831 L22.14426,0.281494831 L4.41008568,0.281494831 C4.38662778,0.281494831 4.36316987,0.281494831 4.36316987,0.281494831 L3.94092763,0.281494831 C3.98784343,0.281494831 4.05821714,0.281494831 4.12859085,0.304952733 C3.19027475,0.422242246 2.46307977,1.21981093 2.46307977,2.18158494 L2.46307977,23.3640709 L2.46307977,23.3640709 L2.06429542,23.3640709 L0.164205318,23.3640709 L0.164205318,24.6307977 C0.164205318,25.5691138 0.891400297,26.3432246 1.8062585,26.4135983 C1.78280059,26.4135983 1.78280059,26.4135983 1.75934269,26.4135983 C1.90009011,26.4135983 2.06429542,26.4135983 2.06429542,26.4135983 L20.5725805,26.4135983 L20.5725805,26.4135983 L20.9948228,26.4135983 C22.0269705,26.4135983 22.8949129,25.5691138 22.8949129,24.5135082 L22.8949129,3.30756426 L23.9505185,3.30756426 L24.4196766,3.30756426 L24.4196766,2.06429542 C24.4196766,1.07906352 23.59865,0.281494831 22.6134181,0.281494831 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    transform: "translate(2.345790, 4.691581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1972541,26.1555613 C20.1972541,26.1555613 18.4144535,26.2259351 18.2502482,24.1381817 C18.2502482,24.0443501 18.2502482,23.2233235 18.2502482,23.1294919 L0.18766322,23.1294919 L0.18766322,24.3962187 C0.18766322,25.3814506 0.985231907,26.1790192 1.97046381,26.1790192 L20.1972541,26.1555613 Z",
    id: "Path",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.407474, 22.988745)",
    fill: "#CCCCCC",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.656821271,0.117289513 C0.656821271,0.117289513 0.656821271,2.25195864 0.656821271,2.48653767 C0.656821271,2.7211167 0.727194979,3.16681684 0.351868538,3.16681684 C0.351868538,3.16681684 0.328410636,3.16681684 0.328410636,3.16681684 C0.469158051,3.16681684 0.656821271,3.16681684 0.656821271,3.16681684 L19.1651064,3.16681684 C20.1972541,3.16681684 21.0651965,2.32233235 21.0651965,1.26672674 L21.0651965,0.117289513 L0.656821271,0.117289513 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.281494831,3.16681684 C0.258036928,3.16681684 0.234579026,3.16681684 0.211121123,3.16681684 C0.211121123,3.16681684 0.234579026,3.16681684 0.281494831,3.16681684 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.9948228,26.1555613 L2.48653767,26.1555613 C2.48653767,26.1555613 1.47784786,26.1555613 1.94700591,26.1555613 C2.41616396,26.1555613 2.48653767,25.7098612 2.48653767,25.4752822 C2.48653767,25.2407031 2.48653767,23.106034 2.48653767,23.106034 L2.48653767,1.92354801 C2.48653767,0.891400297 3.33102216,0.0234579026 4.38662778,0.0234579026 L20.9948228,0.0234579026 C22.0269705,0.0234579026 22.8949129,0.867942394 22.8949129,1.92354801 L22.8949129,24.2554712 C22.8949129,25.3110769 22.0504284,26.1555613 20.9948228,26.1555613 Z",
    id: "Path",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91746973,0.0469158051 C3.91746973,0.0469158051 5.70027032,-0.0234579026 5.86447564,2.06429542 C5.86447564,2.15812703 5.88793354,2.97915362 5.88793354,3.07298523 L23.9505185,3.07298523 L23.9505185,1.8297164 C23.9505185,0.844484492 23.1529498,0.0469158051 22.1677179,0.0469158051 L3.91746973,0.0469158051 Z",
    id: "Path",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38662778,0.0469158051 C4.38662778,0.0469158051 6.16942837,-0.0234579026 6.33363369,2.06429542 C6.33363369,2.15812703 6.35709159,2.97915362 6.35709159,3.07298523 L24.4196766,3.07298523 L24.4196766,1.8297164 C24.4196766,0.844484492 23.6221079,0.0469158051 22.636876,0.0469158051 L4.38662778,0.0469158051 Z",
    id: "Path",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.5638907,6.99045496 L6.49783901,6.99045496 C6.14597047,6.99045496 5.86447564,6.70896013 5.86447564,6.35709159 L5.86447564,6.35709159 C5.86447564,6.00522305 6.14597047,5.72372822 6.49783901,5.72372822 L19.5638907,5.72372822 C19.9157593,5.72372822 20.1972541,6.00522305 20.1972541,6.35709159 L20.1972541,6.35709159 C20.1972541,6.70896013 19.9157593,6.99045496 19.5638907,6.99045496 Z",
    id: "Path",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5638907,9.87577697 L6.49783901,9.87577697 C6.14597047,9.87577697 5.86447564,9.59428214 5.86447564,9.24241361 L5.86447564,9.24241361 C5.86447564,8.89054507 6.14597047,8.60905024 6.49783901,8.60905024 L19.5638907,8.60905024 C19.9157593,8.60905024 20.1972541,8.89054507 20.1972541,9.24241361 L20.1972541,9.24241361 C20.1972541,9.59428214 19.9157593,9.87577697 19.5638907,9.87577697 Z",
    id: "Path",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5638907,12.7845569 L6.49783901,12.7845569 C6.14597047,12.7845569 5.86447564,12.5030621 5.86447564,12.1511935 L5.86447564,12.1511935 C5.86447564,11.799325 6.14597047,11.5178302 6.49783901,11.5178302 L19.5638907,11.5178302 C19.9157593,11.5178302 20.1972541,11.799325 20.1972541,12.1511935 L20.1972541,12.1511935 C20.1972541,12.5030621 19.9157593,12.7845569 19.5638907,12.7845569 Z",
    id: "Path",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5638907,15.6698789 L6.49783901,15.6698789 C6.14597047,15.6698789 5.86447564,15.3883841 5.86447564,15.0365155 L5.86447564,15.0365155 C5.86447564,14.684647 6.14597047,14.4031522 6.49783901,14.4031522 L19.5638907,14.4031522 C19.9157593,14.4031522 20.1972541,14.684647 20.1972541,15.0365155 L20.1972541,15.0365155 C20.1972541,15.3883841 19.9157593,15.6698789 19.5638907,15.6698789 Z",
    id: "Path",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5638907,18.5552009 L6.49783901,18.5552009 C6.14597047,18.5552009 5.86447564,18.2737061 5.86447564,17.9218375 L5.86447564,17.9218375 C5.86447564,17.569969 6.14597047,17.2884742 6.49783901,17.2884742 L19.5638907,17.2884742 C19.9157593,17.2884742 20.1972541,17.569969 20.1972541,17.9218375 L20.1972541,17.9218375 C20.1972541,18.2737061 19.9157593,18.5552009 19.5638907,18.5552009 Z",
    id: "Path",
    fill: "#4A90E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.52652,21.4639808 L6.49783901,21.4639808 C6.14597047,21.4639808 5.86447564,21.182486 5.86447564,20.8306175 L5.86447564,20.8306175 C5.86447564,20.4787489 6.14597047,20.1972541 6.49783901,20.1972541 L12.52652,20.1972541 C12.8783885,20.1972541 13.1598833,20.4787489 13.1598833,20.8306175 L13.1598833,20.8306175 C13.1598833,21.182486 12.8783885,21.4639808 12.52652,21.4639808 Z",
    id: "Path",
    fill: "#4A90E2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    transform: "translate(16.889690, 24.630798)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E06868",
    cx: 3.37793797,
    cy: 2.29887445,
    r: 2.27541655
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37793797,0.0234579026 L3.37793797,4.574291 C4.6212068,4.574291 5.65335452,3.56560119 5.65335452,2.29887445 C5.65335452,1.03214771 4.6212068,0.0234579026 3.37793797,0.0234579026 Z",
    id: "Path",
    fill: "#E76B6B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F9F9F9",
    cx: 3.37793797,
    cy: 2.29887445,
    r: 1.59513737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37793797,0.703737077 L3.37793797,3.89401182 C4.24588036,3.89401182 4.97307534,3.19027475 4.97307534,2.29887445 C4.97307534,1.40747415 4.24588036,0.703737077 3.37793797,0.703737077 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E06868",
    points: "2.06429542 7.52998672 1.47784786 6.35709159 0.18766322 6.75587593 1.50130576 3.58905909 3.37793797 4.36316987"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E76B6B",
    points: "4.66812261 7.52998672 5.27802807 6.35709159 6.56821271 6.75587593 5.25457017 3.58905909 3.37793797 4.36316987"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/test-icon.f8fb5178ae260442775bbf042f6f8689.svg";
export { ForwardRef as ReactComponent };